<template>
	<div class="innerBox">
		<h1>Laporan Work Order</h1>

		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div
				class="row outerBox filterBox"
				style="padding : 0 10px !important;"
			>
				<div class="col row">
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Perusahaan Asuransi</label>
						<!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
						<Multiselect
							v-if="insuranceCompany"
							:options="insuranceCompany.map((x) => x.id)"
							:custom-label="
								(opt) =>
									insuranceCompany.find((x) => x.id == opt)
										.name
							"
							v-model="filter.insurance_company_id"
						/>
					</div>
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Status Pembayaran</label>
						<Multiselect
							:options="
								filterOptions.status_pembayaran.map(
									(x) => x.variable
								)
							"
							:custom-label="
								(opt) =>
									filterOptions.status_pembayaran.find(
										(x) => x.variable == opt
									).label
							"
							v-model="filter.is_paid"
						/>
					</div>
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tanggal Masuk</label>
						<!-- <flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr> -->
						<DatePicker
							class="w-100"
							v-model="selected.date"
							type="monthrange"
							align="right"
							format="MMM yyyy"
							range-separator="-"
							start-placeholder="Start"
							end-placeholder="End"
							:picker-options="pickerOptions"
							style="height:43px">
						</DatePicker>
					</div>
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tanggal Keluar Mobil</label>
						<!-- <flat-pickr
							v-model="selected.dateExit"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr> -->
						<DatePicker
							class="w-100"
							v-model="selected.dateExit"
							type="monthrange"
							align="right"
							format="MMM yyyy"
							range-separator="-"
							start-placeholder="Start"
							end-placeholder="End"
							:picker-options="pickerOptions"
							style="height:43px">
						</DatePicker>
					</div>
					<div
						class="col-md-3 mt-2"
						style="display: flex; flex-direction: column-reverse"
						:class="mobile ? 'pt-20' : ''"
					>
						<button
							type="button"
							class="btn btn-primary"
							style="height:38px; margin-bottom:0.5%"
							@click="updateFilter"
						>
							Filter
						</button>
					</div>
				</div>
			</div>
		</panel>

		<div class="row mt-2 mb-2">
			<div class="col-md-6">
				<stats
					title="Total Keseluruhan"
					:value="
						statsData
							? 'Rp. ' +
							  numberWithCommas(
									parseFloat(statsData.sum_paid) +
										parseFloat(statsData.sum_unpaid)
							  )
							: 'Loading...'
					"
					:sub_value="
						statsData
							? numberWithCommas(
									parseFloat(statsData.paid) +
										parseFloat(statsData.unpaid)
							  )
							: 'Loading...'
					"
					icon="money-check"
					background_color="#FF5B57"
				></stats>
			</div>
			<div class="col-md-3">
				<stats
					title="Total Jasa"
					:value="
						statsData
							?
							  numberWithCommas(
									parseFloat(statsData.total_jasa)
							  )
							: 'Loading...'
					"
					icon="money-check"
					background_color="#4287f5"
				></stats>
			</div>
			<div class="col-md-3">
				<stats
					title="Total Part"
					:value="
						statsData
							?
							  numberWithCommas(
									parseFloat(statsData.total_part)
							  )
							: 'Loading...'
					"
					icon="money-check"
					background_color="#2ea34b"
				></stats>
			</div>
			
		</div>
		<div class="row mt-3 mb-2">
			<div class="col-md-6">
				<stats
					title="Total Lunas"
					:value="
						statsData
							? 'Rp. ' + numberWithCommas(statsData.sum_paid)
							: 'Loading...'
					"
					:sub_value="
						statsData
							? numberWithCommas(statsData.paid)
							: 'Loading...'
					"
					icon="money-bill-wave-alt"
					background_color="#49B6D6"
				></stats>
			</div>
			<div class="col-md-6">
				<stats
					title="Total Belum Lunas"
					:value="
						statsData
							? 'Rp. ' + numberWithCommas(statsData.sum_unpaid)
							: 'Loading...'
					"
					:sub_value="
						statsData
							? numberWithCommas(statsData.unpaid)
							: 'Loading...'
					"
					icon="file"
					background_color="#F59C19"
				></stats>
			</div>
		</div>

		<vue-universal-table
			class="mt-3"
			api_url="/api/v1/insurance/report"
			:update="vue_universal_table.update"
			:fields="vue_universal_table.fields"
			:special_buttons="vue_universal_table.special_buttons"
			:process_data="vue_universal_table.process_data"
			:buttons="vue_universal_table.buttons"
			:filter="filter"
			:page="filter.page"
			@onViewImage="showImage"
			@onPrintKwitansi="showKwitansiModal"
			@getCurrentPage="updatePage"
			@onViewEstimasi="viewEstimator"
			:export_config="vue_universal_table.export_config"
		></vue-universal-table>

		<preview-image
			v-if="imageLink"
			@closeModal="imageLink = null"
			:image="imageLink"
		></preview-image>

		<print-kwitansi 
			v-if="modal.viewKwitansi == true"
			@closeModal="modal.viewKwitansi = false"
			:work_order_code="work_order_code"
		/>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import qs from "qs";
import previewImage from "@/components/modal/previewImage";
import env from "@/env.js";

import stats from "./children/smallStats";
import PrintKwitansi from "./children/showPrintKwitansi";

import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)


export default {
	components: {
		DatePicker,
		Multiselect,
		stats,
		previewImage,
		PrintKwitansi
	},
	data() {
		const start = moment().subtract(4 , 'months').startOf('month').format('YYYY-MM-DD');
		let end  = new moment().endOf('month').format('YYYY-MM-DD')

		let startFilter = new Date().setMonth(new Date().getMonth() - 4)
		let endFilter = new Date()
		let filter = {}
		if(!this.$route.query.start) {
			filter = {
				insurance_company_id: null,
				work_order_code: null,
				is_paid: null,
				start : start, 
				end : end,
				start_car_exit : null,
				end_car_exit : null,
				page : 1
			}

			history.pushState({},
				null,
				this.$route.path +
				'?' +
				Object.keys(filter)
					.map(key => {
					return (
						encodeURIComponent(key) + '=' + encodeURIComponent(filter[key])
					)
					})
					.join('&')
			)
		}
		else {
			let obj = this.$route.query
			console.log(obj)
			// obj.forEach(element => {
			// 	if(obj[element] == 'null') obj[element] = null
			// });
			for(let key in obj) {
				if(obj[key] == 'null') obj[key] = null
			}
			filter = obj
			startFilter = new Date(obj.start)
			endFilter = new Date(obj.end)

			
		}

		console.log(filter)

		
		
		return {
			imageLink: null,
			woList: null,
			insuranceCompany: null,
			mobile: this.isMobile(),
			work_order_code : null,
			modal: {
				view: false,
				viewKwitansi: false,
			},
			pickerOptions: {
				shortcuts: [{
					text: 'Bulan Ini',
					onClick(picker) {
						picker.$emit('pick', [new Date(), new Date()]);
					}
				}, {
					text: 'Tahun Ini',
					onClick(picker) {
						const end = new Date();
						const start = new Date(new Date().getFullYear(), 0);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '6 Bulan Terakhir',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 6);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			
			filterOptions: {
				status_pembayaran: [
					{
						label: "Lunas",
						variable: 1,
					},
					{
						label: "Belum Lunas",
						variable: 0,
					},
					{
						label : 'Belum Penagihan',
						variable: 2
					},
					{
						label : 'Mobil Belum Keluar',
						variable: 3
					}
				],
			},
			rangeConfig: {
				mode: "range",
				altInput: true,
				altInputClass: "form-control input flatpickr-input w-100",
				animate: !this.isRTL(),
			},
			statsData: null,
			selected : {
				date : [
					startFilter,
					endFilter
				],
				dateExit : [],
			},
			filter: filter,
			vue_universal_table: {
				buttons: [
					{
						title: "ViewEstimasi",
						variable: "work_order_code",
						class: "btn-outline-secondary fa fa-file",
					},
					{
						title: "ViewImage",
						variable: "image_kwitansi",
						class: "btn-outline-primary fa fa-image",
					},
					{
						title: "PrintKwitansi",
						variable: "work_order_code",
						class: "btn-outline-success fa fa-file-invoice-dollar",
					},
				],
				fields: [
					{
						title: "No Wo",
						variable: "work_order_code",
					},

					{
						title: "No Polisi",
						variable: "no_pol",
					},
					{
						title: "Nama Customer",
						variable: "nama_customer",
					},
					{
						title: "Asuransi",
						variable: "insurance_company",
					},
					{
						title: "No SPK",
						variable: "no_spk",
					},
					{
						title: "Total Harga",
						variable: "must_pay",
						number_formatting: true,
					},
					{
						title: "Pembayaran",
						variable: "status_pembayaran",
						style_condition: {
							Lunas: "color : green",
							"Belum Lunas": "color : red",
						},
					},
					{
						title: "Status Kwitansi",
						variable: "status_kirim_kwitansi",
						style_condition: {
							"Kwitansi Terkirim": "color : orange",
						},
					},
					{
						title: "Tgl Keluar Mobil",
						variable: "tgl_keluar_mobil",
						date_format: "MMM DD,YYYY HH:mm",
					},
					{
						title: "Tgl Kirim",
						variable: "tgl_kwitansi",
						date_format: "MMM DD,YYYY HH:mm",
					},

					{
						title: "Aging Pembayaran",
						variable: "diff_date",
					},
					// {
					// 	title : 'Tanggal Mulai Work Order',
					// 	variable : 'created_at'
					// }
				],
				special_buttons: ["exportToExcel"],
				process_data: `
						for(var i = 0; i < data.length; i++){
							data[i].must_pay = data[i].must_pay ? data[i].must_pay : 0
							data[i].status_pembayaran = data[i].is_paid ? 'Lunas' : 'Belum Lunas'
							data[i].status_kirim_kwitansi = data[i].status_kwitansi ? 'Sudah Dikirim' : 'Belum Dikirim'
						}
					`,
				update: 0,
				export_config: {
					name: "Laporan Work Order",
					type: "xlsx",
					all: true,
				},
			},
		};
	},
	mounted() {
		this.getStatsData();
		this.getListOfWorkOrder();
		this.getListOfInsuranceCompany();
	},
	watch: {
		"selected.date"() {
			// var date = this.selected.date.split(" to ");
			// this.filter.start = date[0];
			// this.filter.end = date[1] ? date[1] : date[0];
			// console.log
			this.filter.start = new moment(this.selected.date[0]).startOf('month').format('Y-MM-DD')
			this.filter.end = new moment(this.selected.date[1]).endOf('month').format('Y-MM-DD')
		},
		"selected.dateExit"() {
			// var date = this.selected.dateExit.split(" to ");
			// this.filter.start_car_exit = date[0];
			// this.filter.end_car_exit = date[1] ? date[1] : date[0];
			this.filter.start_car_exit = new moment(this.selected.dateExit[0]).startOf('month').format('Y-MM-DD')
			this.filter.end_car_exit = new moment(this.selected.dateExit[1]).endOf('month').format('Y-MM-DD')
		},
		"vue_universal_table.update": function() {
			this.getStatsData();
		},
	},
	methods: {
		viewEstimator(wo_code) {
			this.$router.push({
				name: "EstimatorApplication",
				params: { id: wo_code.replace(/"/g, "") }
			});
		},
		showImage(imageLink) {
			if (!imageLink) {
				this.$store.dispatch("triggerAlert", [
					false,
					"Gambar Bukti Kirim Kwitansi Belum Tersedia",
				]);
				return;
			}
			this.imageLink =
				env.baseImage + "/" + imageLink.split('"').join("");
			console.log(this.imageLink);
		},
		getListOfWorkOrder() {
			this.woList = null;

			this.$http
				.get("/api/v1/masterData/workorder?pagination=false")
				.then((resp) => {
					this.woList = resp.data.data;
					// console.log(this.woList)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getListOfInsuranceCompany() {
			this.insuranceCompany = null;

			this.$http
				.get("/api/v1/insurance/company?pagination=false")
				.then((resp) => {
					this.insuranceCompany = resp.data.data;
					// console.log(this.woList)
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getStatsData() {
			this.$http
				.get(
					`/api/v1/insurance/report/summary${qs.stringify(
						this.filter,
						{ skipNulls: true, addQueryPrefix: true }
					)}`
				)
				.then((resp) => {
					this.statsData = resp.data.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		showKwitansiModal (work_order_code) {
			this.modal.viewKwitansi = true
			this.work_order_code = work_order_code
			
			console.log('test' , this.modal)
		},
		updateFilter() {
			this.updateHistory()
			this.vue_universal_table.update++
		},
		updatePage (page) {
			this.filter.page = page
			this.updateHistory()
			
		},
		updateHistory () {
			history.pushState({},
				null,
				this.$route.path +
				'?' +
				Object.keys(this.filter)
					.map(key => {
					return (
						encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key])
					)
					})
					.join('&')
			)
		}
	},
};
</script>

<style scoped></style>
